import React, { useEffect, useState } from 'react';
import i18n from 'i18n-js';
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import Loading from '../../../Loading';
import { BaseModal } from 'components/UI';
import { getDefaultValues } from 'utils/form';
import FormSchema from 'components/FormSchema';
import { Typography, Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { OrganizationsActions } from 'state/modules/organizations';

const BrokerConnectModal = ({ open, broker, onClose }) => {
  const dispatch = useDispatch();
  const [schema, setSchema] = useState({});

  const { brokerSchema, loading, fetchingEditOrganizationToBrokers } = useSelector(
    (state) => state.organizations
  );

  useEffect(() => {
    if (broker?.org_to_broker_id && open) {
      dispatch(OrganizationsActions.fetchBrokerSchema(broker.org_to_broker_id));
    }
  }, [dispatch, broker?.org_to_broker_id, open]);

  const handleConnect = useCallback(
    (values = {}) => {
      let payload = {};
      payload = { auth_credentials: { ...values } };

      dispatch(OrganizationsActions.editOrganizationToBrokers(broker?.org_to_broker_id, payload));
    },
    [dispatch, broker]
  );

  useEffect(() => {
    if (brokerSchema) {
      const formattedSchema = {
        onSubmit: handleConnect,
        initialValues: getDefaultValues(brokerSchema.auth_schema),
        properties: brokerSchema.auth_schema,
      };
      setSchema(formattedSchema);
    }
  }, [brokerSchema, handleConnect]);

  return (
    <BaseModal size="xl" open={open} enableCloseButton={true} handleClick={onClose}>
      <Box display="flex" flexDirection="column">
        <Typography variant="h6" gutterBottom>
          {i18n.t('organization.broker_connect_title')}
        </Typography>
        <Typography variant="body1" gutterBottom>
          {i18n.t('organization.broker_connect_hint')}
        </Typography>

        {loading ? (
          <Box my={2}>
            <Loading />
          </Box>
        ) : (
          <FormSchema
            schema={schema}
            loading={fetchingEditOrganizationToBrokers}
            submitButtonLabel={i18n.t('organization.broker_connect_action')}
          />
        )}
      </Box>
    </BaseModal>
  );
};

BrokerConnectModal.propTypes = {
  open: PropTypes.bool.isRequired,
  broker: PropTypes.shape({
    vendor_slug: PropTypes.string.isRequired,
    org_to_broker_id: PropTypes.number.isRequired,
    auth_schema: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        type: PropTypes.string,
        required: PropTypes.bool,
        label: PropTypes.string,
        placeholder: PropTypes.string,
        validation_type: PropTypes.string,
        inputProperties: PropTypes.object,
      })
    ),
  }),
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
  onFailure: PropTypes.func,
};

export { BrokerConnectModal };
